<template>
  <div id="app" v-cloak>
    <div class="page-box">
      <keep-alive :include="$store.state.historyList">
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'App',

    data() {
      return {}
    },
    methods: {
      handleBack() {
        this.$store.commit('editIsBack', 1)
      }
    },
    created() {
      window.addEventListener('popstate', this.handleBack, false)
    }
  }
</script>
<style>
	.van-toast {
		z-index: 9999 !important;
	}
  .page-box {
    margin: auto;
    width: 7.5rem;
    min-height: 100%;
  }

  .yd-dialog-white-mask {
    z-index: 9999 !important;
  }

  .van-field__control:disabled,
  .van-field--disabled .van-field__label {
    color: #000 !important;
    -webkit-text-fill-color: #000 !important;
  }

  .toolbar {
    z-index: 1 !important;
  }

  #app {
    min-height: 100%;
    padding: 0;
    margin: 0;
    font-style: '微软雅黑';
    background: #fff;
  }

  .main_page {
    width: 7.5rem;
    margin: 0 auto;
  }

  .mask {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .7);
    z-index: 1999;
  }

  .public-nodata {
    padding-top: 2.6rem;
    padding-bottom: .3rem;
    background: url("~@/assets/img/bg-zwsjb.png")no-repeat top center/2.4rem auto;
    font-size: .28rem;
    color: #505559;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue